import React from 'react';

const DocumentsPage = () => {
  const handleApplyClick = () => {
    // Route to login page
    window.location.href = '/login';
  };

  const keyInstructions = [
    {
      number: 1,
      title: "Enter Valid Email Address",
      description: "Use a valid email address as this will be your username for logging into the portal."
    },
    {
      number: 2,
      title: "Upload Required Files",
      description: "Upload all mandatory files as specified in the form."
    },
    {
      number: 3,
      title: "Provide Accurate Contact Information",
      description: "Enter correct contact details for the person who will handle NOC applications and communications."
    },
    {
      number: 4,
      title: "Complete All Mandatory Fields",
      description: "Fill in all fields marked with (*) before submitting the registration form."
    }
  ];

  const organizedSectorDocs = [
    { id: 1, text: "Registration Certificate *", required: true },
    { id: 2, text: "PAN Card Copy *", required: true },
    { id: 3, text: "Organisation Profile *", required: true },
    { id: 4, text: "Similar Project Details (Optional)", required: false }
  ];

  const communitySectorDocs = [
    { id: 1, text: "Resolution Copy *", required: true },
    { id: 2, text: "PAN Card Copy (optional)", required: false },
    { id: 3, text: "Organisation Profile (optional)", required: false },
    { id: 4, text: "Similar Project Details (Optional)", required: false }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .documents-font {
          font-family: 'Inter', system-ui, sans-serif;
        }
        
        body, html {
          margin: 0;
          padding: 0;
          min-height: 100vh;
        }
      `}</style>
      
      <section className="py-36 documents-font">
        <div className="container mx-auto px-6 lg:px-8 max-w-5xl">
          
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl lg:text-4xl font-semibold text-slate-800 mb-4">
              NGO Registration Requirements
            </h1>
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              Follow these key instructions for completing your NGO registration form
            </p>
          </div>

          {/* Key Instructions */}
          <div className="bg-slate-100 rounded-2xl border-2 border-slate-400 p-8 shadow-xl mb-10">
            <h2 className="text-xl font-semibold text-slate-800 mb-6">
              Registration Instructions
            </h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              {keyInstructions.map((instruction) => (
                <div key={instruction.number} className="flex items-start space-x-4 p-4 rounded-xl border-2 border-slate-400 bg-slate-200">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center text-white font-medium text-sm flex-shrink-0 shadow-lg">
                    {instruction.number}
                  </div>
                  <div>
                    <h3 className="font-medium text-slate-800 mb-1">
                      {instruction.title}
                    </h3>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      {instruction.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Required Documents Section */}
          <div className="bg-slate-100 rounded-2xl border-2 border-slate-400 p-8 shadow-xl mb-10">
            <h2 className="text-xl font-semibold text-slate-800 mb-6">
              Required Documents Checklist
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              {/* Organized Sector */}
              <div className="border-2 border-blue-400 rounded-xl p-6 bg-blue-100">
                <h3 className="text-lg font-medium text-slate-800 mb-4 pb-3 border-b-2 border-blue-300">
                  Organized Sector Documents
                </h3>
                <ul className="space-y-3">
                  {organizedSectorDocs.map((doc) => (
                    <li key={doc.id} className="flex items-start space-x-3">
                      <span className="text-slate-500 font-medium text-sm mt-0.5 w-4">
                        {doc.id}.
                      </span>
                      <span className={`text-sm ${doc.required ? 'text-slate-800 font-medium' : 'text-slate-600'}`}>
                        {doc.text}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Community Organizations */}
              <div className="border-2 border-emerald-400 rounded-xl p-6 bg-emerald-100">
                <h3 className="text-lg font-medium text-slate-800 mb-4 pb-3 border-b-2 border-emerald-300">
                  Community Organization Documents
                </h3>
                <ul className="space-y-3">
                  {communitySectorDocs.map((doc) => (
                    <li key={doc.id} className="flex items-start space-x-3">
                      <span className="text-slate-500 font-medium text-sm mt-0.5 w-4">
                        {doc.id}.
                      </span>
                      <span className={`text-sm ${doc.required ? 'text-slate-800 font-medium' : 'text-slate-600'}`}>
                        {doc.text}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Apply Button */}
          <div className="text-center">
            <button 
              onClick={handleApplyClick}
              className="px-8 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 text-white font-medium rounded-xl shadow-lg hover:shadow-xl hover:from-teal-700 hover:to-emerald-700 focus:ring-4 focus:ring-teal-200/50 transition-all duration-200 transform hover:scale-105"
            >
              Proceed to Application
            </button>
          </div>

        </div>
      </section>
    </div>
  );
};

export default DocumentsPage;